import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

class Info extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
        count: PropTypes.object,
    };

    render() {
        const { data, count } = this.props;

        return (
            <div className={styles.info_box}>
                {data.thumbnailpic !== '' ? (
                    <div className={styles.pic}>
                        <a href={data.url} target="_blank">
                            <LazyImg src={data.thumbnailpic} alt={data.title} width="144" height="80" />
                        </a>
                        {data.type === 'video' ? <div className={styles.v_logo} /> : ''}
                    </div>
                ) : (
                    ''
                )}
                <div className={styles.text_box}>
                    <p className={styles.text}>
                        <a href={data.url} target="_blank" title={data.title}>
                            {data.title}
                        </a>
                    </p>
                    <p className={styles.time}>
                        {data.source ? <span className={styles.source}>{data.source}</span> : ''}
                        {data.newsTime && data.newsTime !== '' ? (
                            <span className={styles.date}>{data.newsTime}</span>
                        ) : (
                            ''
                        )}
                    </p>
                    {count ? (
                        <div className={styles.comment}>
                            <a href={`//gentie.ifeng.com/c/comment/${data.base62Id}`} target="_blank">
                                {count.count}
                            </a>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Info);
